// extracted by mini-css-extract-plugin
export var article = "CtxArticleViewerSection-module--article--82f9c";
export var capitalize = "CtxArticleViewerSection-module--capitalize--be98b";
export var fs14 = "CtxArticleViewerSection-module--fs-14--b61ab";
export var fs16 = "CtxArticleViewerSection-module--fs-16--629a7";
export var fs20 = "CtxArticleViewerSection-module--fs-20--924fe";
export var fs24 = "CtxArticleViewerSection-module--fs-24--67124";
export var fs32 = "CtxArticleViewerSection-module--fs-32--3909b";
export var fs40 = "CtxArticleViewerSection-module--fs-40--b2142";
export var fsItalic = "CtxArticleViewerSection-module--fs-italic--fccc2";
export var fsLg = "CtxArticleViewerSection-module--fs-lg--b6443";
export var fsMd = "CtxArticleViewerSection-module--fs-md--d3dfb";
export var fsNormal = "CtxArticleViewerSection-module--fs-normal--2aa1b";
export var fsSm = "CtxArticleViewerSection-module--fs-sm--704b8";
export var fsXl = "CtxArticleViewerSection-module--fs-xl--0e0ea";
export var fsXs = "CtxArticleViewerSection-module--fs-xs--a4454";
export var fsXxl = "CtxArticleViewerSection-module--fs-xxl--38da6";
export var fsXxs = "CtxArticleViewerSection-module--fs-xxs--809d6";
export var fwBold = "CtxArticleViewerSection-module--fw-bold--119df";
export var fwMedium = "CtxArticleViewerSection-module--fw-medium--3df0a";
export var fwNormal = "CtxArticleViewerSection-module--fw-normal--b8228";
export var gotham_bold = "CtxArticleViewerSection-module--gotham_bold--e8b3d";
export var gotham_bold_italic = "CtxArticleViewerSection-module--gotham_bold_italic--9147a";
export var gotham_book = "CtxArticleViewerSection-module--gotham_book--5cb97";
export var gotham_book_italic = "CtxArticleViewerSection-module--gotham_book_italic--f3fbb";
export var gridContainer = "CtxArticleViewerSection-module--gridContainer--724a0";
export var lowercase = "CtxArticleViewerSection-module--lowercase--ee4f8";
export var navigation = "CtxArticleViewerSection-module--navigation--363dd";
export var template = "CtxArticleViewerSection-module--template--87071";
export var uppercase = "CtxArticleViewerSection-module--uppercase--74f62";